import {
  EntityContactProps,
  useEntityContactsSuspense
} from "@swivu/client-api";
import { PhoneIcon } from "@heroicons/react/24/outline/index.js";
import { ContactCard } from "@swivu/shared-ui";
import CommonStyles from "./CommonStyles.js";

type ContactsProps = EntityContactProps & {
  title: string;
};

const EntityContacts = (variables: ContactsProps) => {
  const { data: contacts } = useEntityContactsSuspense(variables.entity_type)({
    variables
  });

  if (!contacts || contacts.length === 0) return null;
  return (
    <CommonStyles
      Icon={PhoneIcon}
      tone="contacts"
      title={`Contacts`}
      badge={contacts.length}
      cardTitle={`${variables.title}`}
      cardSubtitle={`Contacts`}
      wrapperClassName={`overflow-y-auto`}
    >
      <div className="w-full space-y-3 pt-4">
        {contacts.map((contact) => (
          <ContactCard key={contact.id} contact={contact} />
        ))}
      </div>
    </CommonStyles>
  );
};

export { EntityContacts };
